import React from 'react';
import ReactDOM from 'react-dom';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';

const snackbarId = 'customAlertSnackbar';

const useStyles = makeStyles((theme) => ({
  width: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: 600,
    [theme.breakpoints.up('sm')]: {
      minWidth: 300,
    },
  },
}));

function AlertSnackbar({ message, severity }) {
  const [open, setOpen] = React.useState(true);
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Snackbar
      key={new Date().getTime()}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={handleClose}
        severity={severity || 'success'}
        className={classes.width}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
}

const alertSnackbar = (message, severity) => {
  let snackbar = document.getElementById(snackbarId);
  if (snackbar) {
    ReactDOM.unmountComponentAtNode(snackbar);
  } else {
    snackbar = document.createElement('DIV');
    snackbar.id = snackbarId;
    document.body.appendChild(snackbar);
  }

  ReactDOM.render(
    <AlertSnackbar message={message} severity={severity} />,
    snackbar,
  );
};

global.alertSnackbar = alertSnackbar;
